import {active} from "./const.js";
import $ from "jquery";

  var $win      = $(window);
  var $toTop    = $('#js-toTop');
  var $contents = $('#js-contents');
  var $company  = $('#js-company');

// 初期は非表示
$toTop.hide();

var mqPC = window.matchMedia('(min-width: 768px)');
var mqSP = window.matchMedia('(max-width: 767px)');

function update() {
  var st = $win.scrollTop();
  var wh = $win.height();

  // 200pxでの表示・非表示
  if (st > 200) {
    $toTop.stop(true, true).fadeIn(200);
  } else {
    $toTop.stop(true, true).fadeOut(200);
  }

  // ===== PC：#js-contents 基準 =====
  if (mqPC.matches && $contents.length) {
    var rectC = $contents[0].getBoundingClientRect();
    var inViewC = rectC.top < wh && rectC.bottom > 0;

    if (inViewC) {
      var btnH = $toTop.outerHeight();
      var pad = 10;
      // ボタン中心が #js-contents の上端に重なる（= 自分の高さの半分だけ上）
      var top = rectC.top - (btnH / 2);
      top = Math.max(pad, Math.min(wh - btnH - pad, top));

      $toTop.css({
        position: 'fixed',
        right: '10px',
        bottom: 'auto',
        top: Math.round(top) + 'px'
      });
    } else {
      $toTop.css({ top: 'auto', bottom: '10px', right: '10px' });
    }

  // ===== SP：#js-company 基準 =====
  } else if (mqSP.matches && $company.length) {
      var rectCo = $company[0].getBoundingClientRect();
  var inViewCo = rectCo.top < wh && rectCo.bottom > 0;

  if (inViewCo) {
    var btnH = $toTop.outerHeight();
    var pad = 10;
    var gap = 10; // ← ここで上に持ち上げたい分を指定

    // 「#js-company の上」からさらに gap 分上へ
    var top = rectCo.top - btnH - gap;

    // 画面外にはみ出さないように制御
    top = Math.max(pad, Math.min(wh - btnH - pad, top));

    $toTop.css({
      position: 'fixed',
      right: '10px',
      bottom: 'auto',
      top: Math.round(top) + 'px'
    });
  } else {
    $toTop.css({ top: 'auto', bottom: '10px', right: '10px' });
  }

  } else {
    // 対象要素が無い場合や判定外は通常の右下
    $toTop.css({ top: 'auto', bottom: '10px', right: '10px' });
  }
}

// スクロール・リサイズで更新（rAFで負荷軽減）
var ticking = false;
function onScrollOrResize() {
  if (!ticking) {
    window.requestAnimationFrame(function() {
      update();
      ticking = false;
    });
    ticking = true;
  }
}

$win.on('scroll resize', onScrollOrResize);
mqPC.addEventListener && mqPC.addEventListener('change', update);
mqSP.addEventListener && mqSP.addEventListener('change', update);
update(); // 初期実行
